import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
    loaderContainer: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '100'
    },
    loaderBackground: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        zIndex: 110
    },
    loader: {
        position: 'relative',
        zIndex: 120
    }
}));

export default function Loading(props) {

    const { isLoading, thickness, size, position, opacity, bg } = props
    const classes = useStyles();

    return isLoading ? (
        <div className={classes.loaderContainer} style={{ position: position || 'absolute'}}>
            <CircularProgress
                color="secondary"
                size={size || 70}
                thickness={thickness || 2.8}
                className={classes.loader}
                disableShrink
            />
            <div className={classes.loaderBackground} style={{ opacity: opacity ?? 0.7, backgroundColor: bg ?? '#fff' }}></div>
        </div>
    ) : null;
}
